import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { I18nProvider, getLangFromPath } from "@/i18n/I18nProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/Legal";
import ThankYou from "@/pages/ThankYou";

function LocalizedShell({ children }) {
  const { pathname } = useLocation();
  const lang = getLangFromPath(pathname);
  document.documentElement.lang = lang === "en" ? "en" : "es-MX";
  return (
    <>
      <Header />
      {children}
      <Footer />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/mx" replace />} />

          {/* Thank you (Spanish only, no localized header/footer wrapper) */}
          <Route path="/thank_you" element={<ThankYou />} />

          {/* Spanish */}
          <Route
            path="/mx"
            element={
              <LocalizedShell>
                <Home />
              </LocalizedShell>
            }
          />
          <Route
            path="/mx/privacidad"
            element={
              <LocalizedShell>
                <PrivacyPage />
              </LocalizedShell>
            }
          />
          <Route
            path="/mx/cookies"
            element={
              <LocalizedShell>
                <CookiesPage />
              </LocalizedShell>
            }
          />
          <Route
            path="/mx/terminos"
            element={
              <LocalizedShell>
                <TermsPage />
              </LocalizedShell>
            }
          />

          {/* English */}
          <Route
            path="/en"
            element={
              <LocalizedShell>
                <Home />
              </LocalizedShell>
            }
          />
          <Route
            path="/en/privacy"
            element={
              <LocalizedShell>
                <PrivacyPage />
              </LocalizedShell>
            }
          />
          <Route
            path="/en/cookies"
            element={
              <LocalizedShell>
                <CookiesPage />
              </LocalizedShell>
            }
          />
          <Route
            path="/en/terms"
            element={
              <LocalizedShell>
                <TermsPage />
              </LocalizedShell>
            }
          />

          {/* Fallback → default Spanish home */}
          <Route path="*" element={<Navigate to="/mx" replace />} />
        </Routes>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
